import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, CONSENT_EVENT } from "@/lib/ads";

const T = {
  text: {
    lv: "Mēs izmantojam reklāmas sīkdatnes, lai mērītu Google Ads efektivitāti. Jūs varat tās pieņemt vai noraidīt.",
    ru: "Мы используем рекламные cookies, чтобы измерять эффективность рекламы Google Ads. Вы можете принять или отклонить их.",
    en: "We use advertising cookies to measure the performance of our Google Ads. You can accept or decline them.",
  },
  more: { lv: "Privātuma politika", ru: "Политика конфиденциальности", en: "Privacy policy" },
  accept: { lv: "Pieņemt", ru: "Принять", en: "Accept" },
  decline: { lv: "Noraidīt", ru: "Отклонить", en: "Decline" },
};

export const CookieConsent = () => {
  const [open, setOpen] = useState(() => !getConsent());
  const language = localStorage.getItem("language") || "lv";
  const t = (k) => T[k][language] || T[k].lv;

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(CONSENT_EVENT, show);
    return () => window.removeEventListener(CONSENT_EVENT, show);
  }, []);

  if (!open) return null;
  const choose = (granted) => { setConsent(granted); setOpen(false); };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-5" data-testid="cookie-consent-banner">
      <div className="max-w-[880px] mx-auto bg-[#1C1917] text-[#F5F2EC] p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 shadow-2xl">
        <p className="text-sm leading-relaxed m-0 flex-1">
          {t("text")}{" "}
          <Link to="/privacy" className="underline underline-offset-4 text-[#F5F2EC]" data-testid="cookie-privacy-link">{t("more")}</Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <button type="button" onClick={() => choose(false)} className="px-5 py-2.5 text-sm border border-[#F5F2EC]/40 hover:bg-[#F5F2EC]/10 transition-colors" data-testid="cookie-decline-btn">{t("decline")}</button>
          <button type="button" onClick={() => choose(true)} className="px-5 py-2.5 text-sm bg-[#F5F2EC] text-[#1C1917] hover:bg-white transition-colors" data-testid="cookie-accept-btn">{t("accept")}</button>
        </div>
      </div>
    </div>
  );
};
